/**
 * Forma normale di un tag (F-079).
 *
 * ## Perché esiste anche qui, se il backend la applica comunque
 *
 * Non per fidarsi del client — il server rinormalizza sempre, e il vincolo del
 * database rifiuta ciò che non è normalizzato. Serve a **mostrarlo mentre si
 * scrive**: il chip appare minuscolo appena aggiunto, così chi digita «USA»
 * scopre subito che diventa «usa» invece di trovarselo cambiato dopo aver
 * salvato. Le due copie devono restare d'accordo, ed è per questo che la regola
 * sta in un file suo in entrambi i progetti invece che sparsa nei componenti.
 */

/** Deve corrispondere a `TAG_MAX_LENGTH` del backend e a `VARCHAR(40)`. */
export const TAG_MAX_LENGTH = 40;

/** Deve corrispondere a `MAX_TAGS_PER_INSTRUMENT` del backend. */
export const MAX_TAGS_PER_INSTRUMENT = 20;

export function normalizeTag(raw: string): string {
  return raw.trim().toLowerCase().replace(/\s+/g, ' ').slice(0, TAG_MAX_LENGTH).trim();
}
